import React, { Fragment } from "react"
import { isMember, pgaComTld } from "../utils"
import bannerOptions from "./bannerOptions"
import { Wrapper, Title, TitleLink } from "./styles"

const OrdersWarning = ({ orders }) => {
  const hasPayableOrders = orders?.some(order => {
    const orderDate = new Date(order.createdAt)
    const cutoffDate = new Date("2023-12-31T23:59:59Z")

    return (
      order.payable &&
      order.balance > 0 &&
      !order.canceled &&
      order.orderType !== "education" &&
      orderDate > cutoffDate
    )
  })

  if (!hasPayableOrders) return null

  return (
    <Wrapper color="maroon" textColor="white">
      <Title textColor="white">
        You have pending invoices that require payment.
      </Title>
      <TitleLink
        href={`https://${pgaComTld}/member/account/invoices`}
        target="_blank"
        rel="noopener noreferrer"
        textColor="white"
      >
        View Invoices
      </TitleLink>
    </Wrapper>
  )
}

export const GenericBanner = ({
  color,
  textColor,
  title,
  link,
  linkText,
  removeMarginTop,
}) => {
  return (
    <Wrapper color={color} removeMarginTop={removeMarginTop}>
      <Title textColor={textColor}>{title}</Title>
      {link && (
        <TitleLink href={link} textColor={textColor}>
          {linkText}
        </TitleLink>
      )}
    </Wrapper>
  )
}

const Banners = ({ me, currentPerson }) => {
  return (
    <>
      <OrdersWarning orders={currentPerson?.orders} />
      {bannerOptions.map((banner, index) => {
        const displayForMembersOrPublic = banner.membersOnly
          ? banner.showBanner && isMember(me)
          : banner.showBanner
        return displayForMembersOrPublic ? (
          <GenericBanner key={index} {...banner} />
        ) : null
      })}
    </>
  )
}

export default Banners
